/* eslint-disable */

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://za43ztvjcre7rdjy5fzxwzr7fq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:bb8fcb8d-21a3-4b4e-b990-701ea4dc4ac1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_WOKNcxqxl",
    "aws_user_pools_web_client_id": "3t5jgs01pri5u3o902oid38sru",
    "oauth": {
        "domain": "spiggl-login-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://spiggl.com,http://localhost:3000",
        "redirectSignOut": "https://spiggl.com,http://localhost:3000",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": "8",
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "bluebucketa4254-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
